"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("./state"));
var navigation_button_1 = __importStar(require("../views/navigation-button"));
var title_container_1 = __importDefault(require("../views/title-container"));
var game_area_1 = require("../utilities/game-area");
var foam_emitter_1 = __importDefault(require("../emitters/foam-emitter"));
var shower_emitter_1 = __importDefault(require("../emitters/shower-emitter"));
var bubble_emitter_1 = __importDefault(require("../emitters/bubble-emitter"));
var color_1 = require("../utilities/color");
var stack_container_1 = __importStar(require("../views/stack-container"));
var calculator_1 = require("../models/calculator");
var i18next_1 = __importDefault(require("i18next"));
var gsap_1 = require("gsap");
var PixiPlugin_1 = require("gsap/PixiPlugin");
var gesture_recognizer_1 = __importDefault(require("../utilities/gesture-recognizer"));
gsap_1.gsap.registerPlugin(PixiPlugin_1.PixiPlugin);
PixiPlugin_1.PixiPlugin.registerPIXI(PIXI);
var CleanState = /** @class */ (function (_super) {
    __extends(CleanState, _super);
    function CleanState(app, client, backdropContainer, dragonContainer) {
        var _this = _super.call(this) || this;
        _this._app = app;
        _this._client = client;
        _this._backdropContainer = backdropContainer;
        _this._dragonContainer = dragonContainer;
        return _this;
    }
    Object.defineProperty(CleanState.prototype, "foamEmitter", {
        get: function () {
            if (!this._foamEmitter) {
                this._foamEmitter = new foam_emitter_1.default();
            }
            return this._foamEmitter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CleanState.prototype, "showerEmitter", {
        get: function () {
            if (!this._showerEmitter) {
                this._showerEmitter = new shower_emitter_1.default();
            }
            return this._showerEmitter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CleanState.prototype, "bubbleEmitter", {
        get: function () {
            if (!this._bubbleEmitter) {
                this._bubbleEmitter = new bubble_emitter_1.default();
            }
            return this._bubbleEmitter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CleanState.prototype, "showerHead", {
        get: function () {
            if (!this._showerHead) {
                this._showerHead = PIXI.Sprite.from("assets/showerHead.png");
                this._showerHead.anchor.set(0.5, 0.9);
                this._showerHead.scale.set(0.5);
                this._showerHead.position.set(game_area_1.GAME_WIDTH * 0.5, -game_area_1.GAME_PADDING_Y);
            }
            return this._showerHead;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CleanState.prototype, "backButton", {
        get: function () {
            var _this = this;
            if (!this._backButton) {
                this._backButton = new navigation_button_1.default(this._app.loader.resources.ui.textures, navigation_button_1.NAVIGATION_BUTTON_TYPE.BACK, function () {
                    _this.stopShower(0.7);
                });
                this._backButton.position.set(game_area_1.GAME_SAFE_AREA.left + 12, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._backButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CleanState.prototype, "titleContainer", {
        get: function () {
            if (!this._titleContainer) {
                this._titleContainer = new title_container_1.default(this._app.loader.resources.ui.textures);
                this._titleContainer.setText(i18next_1.default.t("clean_title"));
                this._titleContainer.position.set((game_area_1.GAME_WIDTH - this._titleContainer.width) * 0.5, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._titleContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CleanState.prototype, "titleLabel", {
        get: function () {
            if (!this._titleLabel) {
                this._titleLabel = new PIXI.Text("");
                this._titleLabel.style = {
                    fontFamily: "Arial",
                    fontWeight: "bold",
                    align: "center",
                    fontSize: 35,
                    fill: color_1.COLOR.WHITE
                };
            }
            return this._titleLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CleanState.prototype, "tipLabel", {
        get: function () {
            if (!this._tipLabel) {
                this._tipLabel = new PIXI.Text("");
                this._tipLabel.style = {
                    fontFamily: "Arial",
                    fontSize: 21,
                    fill: color_1.COLOR.GREEN
                };
            }
            return this._tipLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CleanState.prototype, "stackContainer", {
        get: function () {
            if (!this._stackContainer) {
                this._stackContainer = new stack_container_1.default([
                    this.titleLabel,
                    this.tipLabel
                ], {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 6,
                    minWidth: game_area_1.GAME_WIDTH
                });
                this._stackContainer.position.set(0, game_area_1.GAME_SAFE_AREA.bottom - this._stackContainer.height - 10);
            }
            return this._stackContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CleanState.prototype, "gestureRecognizer", {
        get: function () {
            var _this = this;
            if (!this._gestureRecognizer) {
                this._gestureRecognizer = new gesture_recognizer_1.default();
                this._gestureRecognizer
                    .onScrubBegin(function () {
                    _this.isScrubbing = true;
                })
                    .onScrubEnd(function () {
                    _this.isScrubbing = false;
                });
            }
            return this._gestureRecognizer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CleanState.prototype, "isScrubbing", {
        get: function () {
            return this._isScrubbing;
        },
        set: function (value) {
            if (this._isScrubbing == value) {
                return;
            }
            this._isScrubbing = value;
            this.foamEmitter.emit = value;
            this.bubbleEmitter.emit = value;
            value ? this._dragonContainer.setRubAnimation() : this._dragonContainer.setIdleAnimation();
        },
        enumerable: false,
        configurable: true
    });
    CleanState.prototype.didEnterFrom = function (previousState) {
        _super.prototype.didEnterFrom.call(this, previousState);
        this._app.stage.addChild(this._backdropContainer);
        this._app.stage.addChild(this.foamEmitter.parent);
        this._app.stage.addChild(this.showerEmitter.parent);
        this._app.stage.addChild(this.bubbleEmitter.parent);
        this._app.stage.addChild(this.showerHead);
        this._app.stage.addChild(this.backButton);
        this._app.stage.addChild(this.titleContainer);
        this._app.stage.addChild(this.stackContainer);
        this._dragonContainer.interactive = true;
        this.gestureRecognizer.addTo(this._dragonContainer);
        this._dragonContainer.setIdleAnimation();
        this._backdropContainer.dragonSlot.addChild(this._dragonContainer);
        this.startShower();
        this._washTime = 0;
        this._client.sendEvent("clean_entered");
    };
    CleanState.prototype.willExitTo = function (nextState) {
        _super.prototype.willExitTo.call(this, nextState);
        this._app.stage.removeChild(this._backdropContainer);
        this._app.stage.removeChild(this.foamEmitter.parent);
        this._app.stage.removeChild(this.showerEmitter.parent);
        this._app.stage.removeChild(this.bubbleEmitter.parent);
        this._app.stage.removeChild(this.showerHead);
        this._app.stage.removeChild(this.backButton);
        this._app.stage.removeChild(this.titleContainer);
        this._app.stage.removeChild(this.stackContainer);
        this.foamEmitter.cleanup();
        this.showerEmitter.cleanup();
        this.bubbleEmitter.cleanup();
        this._dragonContainer.interactive = false;
        this.gestureRecognizer.removeFromContainer();
        this._backdropContainer.dragonSlot.removeChild(this._dragonContainer);
    };
    CleanState.prototype.update = function (deltaTime) {
        this.gestureRecognizer.update(deltaTime);
        if (this.isScrubbing) {
            var position = this._app.stage.toLocal(this.gestureRecognizer.touchPosition, this.gestureRecognizer.container);
            this.foamEmitter.updateSpawnPos(position.x, position.y);
            this.bubbleEmitter.updateSpawnPos(position.x, position.y);
            this._washTime += deltaTime;
            this.titleLabel.text = Math.ceil((10000 - this._washTime) / 1000).toFixed();
            if (this._washTime > 8000) {
                this.tipLabel.text = i18next_1.default.t("clean_step_3");
            }
            else if (this._washTime > 5000) {
                this.tipLabel.text = i18next_1.default.t("clean_step_2");
            }
            else {
                this.tipLabel.text = i18next_1.default.t("clean_step_1");
            }
            this.stackContainer.layoutChildren();
            if (this._washTime > 10000) {
                this._washTime = null;
                this._dragonContainer.interactive = false;
                this.congratulate();
            }
        }
    };
    CleanState.prototype.startShower = function () {
        var _this = this;
        gsap_1.gsap.to(this.showerHead, {
            duration: 0.5,
            y: 130,
            ease: "Power1.easeInOut",
            onComplete: function () {
                _this.showerEmitter.updateSpawnPos(_this.showerHead.x, _this.showerHead.y);
                _this.showerEmitter.emit = true;
            }
        });
        this.titleLabel.text = i18next_1.default.t("clean_caption");
        this.tipLabel.text = i18next_1.default.t("clean_hint");
        this.stackContainer.layoutChildren();
    };
    CleanState.prototype.stopShower = function (duration) {
        var _this = this;
        this.foamEmitter.emit = false;
        this.showerEmitter.emit = false;
        this.bubbleEmitter.emit = false;
        gsap_1.gsap.to(this.showerHead, {
            duration: duration,
            y: -game_area_1.GAME_PADDING_Y,
            ease: "Power1.easeInOut",
            onComplete: function () {
                _this.stateMachine.pop();
            }
        });
    };
    CleanState.prototype.congratulate = function () {
        var points = calculator_1.CLEAN_XP;
        this.titleLabel.text = i18next_1.default.t("clean_finish_caption");
        this.tipLabel.text = i18next_1.default.t("clean_finish_subtitle")
            .replace("[points]", points.toFixed());
        this.stackContainer.layoutChildren();
        this._client.adjustMeters({
            calmness: 0,
            nutrition: 0,
            hygiene: 50,
            energy: 0
        });
        this._client.award(points);
        this._client.synchronize();
        this._client.sendEvent("clean_finished");
        this.stopShower(3);
    };
    return CleanState;
}(state_1.default));
exports.default = CleanState;
